import { css } from "styled-components";
import { media } from "../../../theme/media";
export const modalSizes = {
    "50": css `
    max-width: min(504px, 96vw);
  `,
    "100": css `
    max-width: min(504px, 96vw);

    ${media.laptop} {
      max-width: min(648px, 96vw);
    }
  `,
    "200": css `
    max-width: min(504px, 96vw);

    ${media.laptop} {
      max-width: min(648px, 96vw);
    }

    ${media.desktop} {
      max-width: min(864px, 96vw);
    }
  `,
    "400": css `
    max-width: min(504px, 96vw);

    ${media.laptop} {
      max-width: min(648px, 96vw);
    }

    ${media.desktop} {
      max-width: min(864px, 96vw);
    }

    ${media.extraDesktop} {
      max-width: min(1152px, 96vw);
    }
  `,
};
